module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@3x-582bd2f986aea756cd3c82bc2df035e5.png";